import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageService } from 'primeng/api';
import { CommunicationService } from 'src/app/services/communication/communication.service';
import { MessagesModule } from 'primeng/messages';
import { RadioButtonClickEvent, RadioButtonModule } from 'primeng/radiobutton';
import { CardModule } from 'primeng/card';
import { InputIconModule } from 'primeng/inputicon';
import { NewPaymentMethodFormComponent } from '../new-payment-method-form/new-payment-method-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { paymentMethod } from '../../../../../../express-tRPC/src/shared/types';
import { TagModule } from 'primeng/tag';

@Component({
  selector: 'payment-method-selection',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MessagesModule, RadioButtonModule, CardModule, InputIconModule, NewPaymentMethodFormComponent, TagModule],
  providers: [MessageService],
  templateUrl: './payment-method-selection.component.html',
  styleUrl: './payment-method-selection.component.scss'
})
export class PaymentMethodSelectionComponent {

  cardForm: any;
  @Input('module') module!: string;
  @Input('AllowCheckMethod') AllowCheckMethod: boolean | undefined;
  @Input('NotAllowedACHMethod') NotAllowedACHMethod!: boolean;
  @Input('tokenizationSourceKey') tokenizationSourceKey: string | undefined;
  @Input('isPaymentEnabled') isPaymentEnabled: boolean | undefined;
  @Output() paymentMethodSelectedEvent = new EventEmitter<paymentMethod>();

  selectedPaymentMethod: paymentMethod | undefined;
  paymentMethods: paymentMethod[] | undefined = [];
  isNewPaymentMethod: boolean = false;

  @ViewChild(NewPaymentMethodFormComponent) newPaymentMethodComponent!: NewPaymentMethodFormComponent;

  constructor(
    private messageService: MessageService,
    private commService: CommunicationService
  ) { }

  ngOnInit() {
    this.getPaymentMethods();
  }

  async getPaymentMethods(): Promise<void> {
    let paymentMethodsResult: any = await this.commService.getPaymentMethods(this.module)?.catch((error: any) => {
      this.messageService.clear();
      this.messageService.add({
        severity: "error",
        detail: error.message,
        key: 'general-toast-message'
      });
    });
    this.paymentMethods = paymentMethodsResult;

    //Filter payment menthod and remove 'Bill Me' payment method
    //If 'isPaymentEnabled' and 'NotAllowedACHMethod' is true
    if(this.NotAllowedACHMethod && this.isPaymentEnabled) {
      this.paymentMethods = this.paymentMethods?.filter((pMethod: paymentMethod) => pMethod.name != "Bill Me")
    }

    if(this.paymentMethods?.length == 1) {
      this.selectedPaymentMethod = this.paymentMethods[0];
    } else {
      this.selectedPaymentMethod = this.paymentMethods?.find((pMethod: paymentMethod) => pMethod.is_default);
    }

    if (!this.paymentMethods?.length || !this.selectedPaymentMethod) {
      this.isNewPaymentMethod = true;
      await this.newPaymentMethodComponent.initPaymentIframe();
    }

    if(!this.isNewPaymentMethod) {
      this.paymentMethodSelectedEvent.emit(this.selectedPaymentMethod);
    }
  }

  async newPaymentMethodDetails(pMethod: paymentMethod) {
    this.paymentMethodSelectedEvent.emit(pMethod);
  }

  async paymentMethodChanged(event: RadioButtonClickEvent): Promise<void> {
    this.messageService.clear();
    if (event.value == 'new') {
      //We got an error because we try to call initPaymentIframe() method before component initiazed
      //So we have wraped function into setTimeout
      setTimeout(async () => {
        await this.newPaymentMethodComponent.initPaymentIframe();
      }, 0);

      // this.paymentMethodSelectedEvent.emit(undefined);
      this.isNewPaymentMethod = true;
    } else {
      this.isNewPaymentMethod = false;
      this.paymentMethodSelectedEvent.emit(this.selectedPaymentMethod);
    }
  }

  public async resetPaymentForm() {
    this.newPaymentMethodComponent?.resetForm();
    this.selectedPaymentMethod = this.paymentMethods?.find((pMethod: paymentMethod) => pMethod.is_default)
  }

  public async showCardFormError(error: any) {
    this.messageService.clear();
    this.messageService.add({
      severity: "error",
      detail: error.message,
      key: 'payment-form-error-message'
    });
  }

  public async validatePaymentForm(): Promise<paymentMethod | undefined> {

    try {
      this.messageService.clear();

      let savePaymentMethodReq: paymentMethod | undefined = undefined;

      //Check if selected method is new or existing
      if (this.isNewPaymentMethod) {
        //OK its new method so we have to validate form before save new payment method
        savePaymentMethodReq = await this.newPaymentMethodComponent.validateForm();
      } else {
        //Aah! its existing payment method so just return selected method details
        savePaymentMethodReq = this.selectedPaymentMethod;
      }

      return savePaymentMethodReq;
    } catch (error: any) {
      return undefined;
    }

  }

}
